import { Link } from "react-router-dom";
import { Mail, ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#dcfce7]" data-testid="main-footer">
      {/* Cofinanciación */}
      <div className="border-b border-[#bbf7d0]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="text-center text-sm text-slate-700 mb-8">
            Proyecto financiado por la Unión Europea mediante el Mecanismo de
            Recuperación y Resiliencia - NextGeneration EU
          </p>
          <div className="flex justify-center">
            <a
              href="https://www.caib.es/webgoib/w/conselleria-turisme-cultura-i-esports"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              title="Conselleria de Turisme, Cultura i Esports"
            >
              <img
                src="/assets/logos/logos-institucionales.png"
                alt="Logos de cofinanciación: Unión Europea NextGeneration EU, Ministerio de Industria y Turismo, Plan de Recuperación Transformación y Resiliencia, Conselleria de Turisme Cultura i Esports"
                className="max-w-full h-auto max-h-20 object-contain"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="/assets/logos/sostre-balear-dark.png"
              alt="SOSTRE BALEAR"
              className="h-16 w-auto mb-4"
            />
            <p className="text-slate-700 text-sm leading-relaxed max-w-md">
              Estudio de viabilidad para el desarrollo a gran escala de vivienda
              industrializada sobre suelo público en alquiler a empresas del
              sector turístico de Baleares.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-slate-900 mb-4">Navegación</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/entregables"
                  className="text-slate-600 hover:text-[#16a34a] transition-colors text-sm"
                >
                  Entregables
                </Link>
              </li>
              <li>
                <Link
                  to="/normativa"
                  className="text-slate-600 hover:text-[#16a34a] transition-colors text-sm"
                >
                  Normativa
                </Link>
              </li>
              <li>
                <Link
                  to="/mapa"
                  className="text-slate-600 hover:text-[#16a34a] transition-colors text-sm"
                >
                  Mapa de Suelo
                </Link>
              </li>
              <li>
                <Link
                  to="/documentacion"
                  className="text-slate-600 hover:text-[#16a34a] transition-colors text-sm"
                >
                  Documentación
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-slate-900 mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:info@pastoria.es"
                  className="flex items-center gap-2 text-slate-600 hover:text-[#16a34a] transition-colors text-sm"
                >
                  <Mail size={16} />
                  info@pastoria.es
                </a>
              </li>
              <li>
                <a
                  href="https://www.pastoria.es"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-slate-600 hover:text-[#16a34a] transition-colors text-sm"
                >
                  <ExternalLink size={16} />
                  www.pastoria.es
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#bbf7d0] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
            <p className="text-slate-600 text-sm">
              © {new Date().getFullYear()} SOSTRE BALEAR. Todos los derechos
              reservados.
            </p>
            <p className="text-slate-700 text-sm font-medium" data-testid="footer-pastoria">
              Estudio redactado por{" "}
              <span className="text-[#16a34a] font-semibold">PASTORIA PROJECT SL</span>
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-4 text-sm">
            <Link
              to="/politica-privacidad"
              className="text-slate-500 hover:text-[#16a34a] transition-colors"
            >
              Política de Privacidad
            </Link>
            <span className="text-slate-300">|</span>
            <Link
              to="/politica-cookies"
              className="text-slate-500 hover:text-[#16a34a] transition-colors"
            >
              Política de Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
